<div class="container">
    <div class="login-wrapper row">

        <!-- LEFT LOGIN FORM -->
        <div class="col-md-6 left-box">

            <h2>Welcome</h2>
            <p class="subtitle">Login with email</p>

            <form id="loginForm" [formGroup]="form" (ngSubmit)="submit()">

                <!-- USERNAME -->
                <div class="mb-3 position-relative">
                    <span class="position-absolute top-50 translate-middle-y ms-3 text-muted">
                        <i class="fa fa-user"></i>
                    </span>
                    <input type="email" class="form-control ps-5" placeholder="Email" formControlName="email"
                        required />
                    <div class="invalid-feedback">
                        Email is required.
                    </div>
                </div>

                <!-- PASSWORD -->
                <div class="mb-3 position-relative">
                    <span class="position-absolute top-50 translate-middle-y ms-3 text-muted">
                        <i class="fa fa-lock"></i>
                    </span>

                    <input id="passwordField" [type]="showPassword ? 'text' : 'password'" class="form-control ps-5" formControlName="password"
                        placeholder="Password" required />

                    <!-- Toggle icon -->
                    <span class="position-absolute top-50 translate-middle-y end-0 me-3 text-muted"
                        (click)="togglePassword()" style="cursor:pointer;">
                        <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>

                    <div class="invalid-feedback">
                        Password is required.
                    </div>
                </div>

                <!-- LOGIN BUTTON -->
                <button type="submit" class="btn-login">Login Now</button>
            </form>

            <!-- <hr class="my-4" />
            <h6 class="text-center mb-3 fw-bold">Login with Others</h6>
    
            <button class="social-btn mb-2">
                <img src="https://www.svgrepo.com/show/475656/google-color.svg" width="22" class="me-2">
                Login with Google
            </button> -->
        </div>

        <!-- RIGHT IMAGE PANEL -->
        <div class="col-md-6 right-box">
            <img src="https://images.pexels.com/photos/4145354/pexels-photo-4145354.jpeg" alt="Login Image">
        </div>

    </div>
</div>